<div class="icon-menu-rail">
  @if (isPosShell()) {
    <div class="icon-menu-rail__brand" aria-hidden="true">
      <img
        [src]="posIsotypeBlackSrc"
        class="app-isotype app-isotype--light"
        width="32"
        height="32"
        alt=""
      />
      <img
        [src]="posIsotypeWhiteSrc"
        class="app-isotype app-isotype--dark"
        width="32"
        height="32"
        alt=""
      />
    </div>
  }

  <mat-nav-list class="text-center sidebar-tooltip icon-menu-rail__primary">
    @if (!isPosShell()) {
      <button
        mat-icon-button
        extended
        color="inherit"
        (click)="toggleCollapsed.emit()"
        class="icon-menu-rail__toggle"
      >
        <i class="iconify text-xl" data-icon="solar:hamburger-menu-line-duotone"></i>
      </button>
    }

    @for (item of getFlattenedItems(menuItems); track item.id) {
      <mat-list-item
        cdkOverlayOrigin
        #itemOrigin="cdkOverlayOrigin"
        [class.is-active]="item.id === selectedMenu"
        class="menu-list-item icon-menu-item p-0!"
        (click)="selectIcon(item.id)"
        (mouseenter)="onRailItemEnter(itemOrigin, item.id)"
        (mouseleave)="onRailItemLeave()"
      >
        <div class="icon-menu-item__content">
          <span class="icon-menu-item__icon-wrap">
            <span class="iconify icon-menu-item__icon" [attr.data-icon]="item.iconName"></span>
            @if (item.planLocked) {
              <span class="icon-menu-item__plan-dot" aria-hidden="true"></span>
            }
            @if (item.id === pedidosRailId && hubPendingCount() > 0) {
              <span class="icon-menu-item__count-badge" aria-hidden="true">{{
                hubPendingCount() > 99 ? '99+' : hubPendingCount()
              }}</span>
            }
          </span>
          <span class="icon-menu-item__label">{{ item.title | translate }}</span>
        </div>
      </mat-list-item>
    }

    @if (showContextSwitch()) {
      <mat-list-item
        class="menu-list-item icon-menu-item icon-menu-item--context p-0! mt-1"
        (click)="onContextSwitch()"
      >
        <div class="icon-menu-item__content">
          <span class="icon-menu-item__icon-wrap icon-menu-item__icon-wrap--accent">
            <span class="iconify icon-menu-item__icon" [attr.data-icon]="contextSwitchIcon()"></span>
          </span>
          <span class="icon-menu-item__label">{{ contextSwitchLabelKey() | translate }}</span>
        </div>
      </mat-list-item>
    }
  </mat-nav-list>
</div>

@if (flyoutOrigin) {
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="flyoutOrigin"
    [cdkConnectedOverlayOpen]="flyoutOpen"
    [cdkConnectedOverlayPositions]="flyoutPositions"
    [cdkConnectedOverlayPush]="true"
    [cdkConnectedOverlayViewportMargin]="12"
    (overlayOutsideClick)="closeFlyoutFromOutside()"
  >
    <div
      class="rail-module-flyout"
      role="menu"
      (mouseenter)="onFlyoutEnter()"
      (mouseleave)="onFlyoutLeave()"
    >
      <span class="rail-module-flyout__caret" aria-hidden="true"></span>
      <div class="rail-module-flyout__body">
        @for (child of flyoutChildren; track trackFlyoutChild(child, $index)) {
          @if (child.navCap) {
            <div
              class="rail-module-flyout__cap"
              [class.rail-module-flyout__cap--brand]="child.navCapBrand"
              [class.rail-module-flyout__cap--divider]="child.divider"
            >
              {{ child.navCap }}
            </div>
          } @else if (child.route) {
            <a
              class="rail-module-flyout__link"
              role="menuitem"
              href="#"
              [class.is-active]="isRouteActive(child.route)"
              [class.is-disabled]="child.disabled"
              (click)="onFlyoutLinkClick($event, child)"
            >
              @if (child.iconName) {
                <span class="iconify rail-module-flyout__icon" [attr.data-icon]="child.iconName"></span>
              }
              <span class="rail-module-flyout__text">{{ child.displayName | translate }}</span>
              @if ((child.route === '/pos/pedidos' || child.route === '/sales/pos/pedidos') && hubPendingCount() > 0) {
                <span class="rail-module-flyout__count">{{
                  hubPendingCount() > 99 ? '99+' : hubPendingCount()
                }}</span>
              }
              @if (child.planLocked) {
                <span class="rail-module-flyout__plan">Plan</span>
              }
            </a>
          }
        }
      </div>
    </div>
  </ng-template>
}
